import BlogMidCTA from "../../../../src/components/BlogMidCTA";
import mcplist from "../../../../assets/images/blogs/chromemcp/list.png";
import mcpchange from "../../../../assets/images/blogs/chromemcp/change.png";
import * as React from 'react';
export default {
  BlogMidCTA,
  mcplist,
  mcpchange,
  React
};